import MissingInfoDialog from './MissingInfoDialog';

export default MissingInfoDialog;
